import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';
import { toast } from 'react-toastify';
import useCenterService from '../../../app/services/hooks/useCenterService';
import { CenterDataForm } from '../../../app/models/Center';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import CenterForm from './forms/CenterForm';

interface Props {
  onSaved?: () => void;
  onCancel?: () => void;
  onError?: () => void;
}

const NOOP = () => undefined;

// src/pages/Centers/components/CenterCreate.tsx
const CenterCreate = ({ onSaved, onCancel, onError }: Props) => {
  const { showLoading, hideLoading } = useContext(AppContext);
  const { createCenter, storeCenter, fetchingStoreCenter } = useCenterService();
  const handleCancel = onCancel ?? NOOP;
  const [societies, setSocieties] = useState<{id:number|string; name:string}[]>([]);

  const [center, setCenter] = useState<CenterDataForm>({
    society_id: undefined,   // ✅ requerido por backend
    name: '',
    address: '',
    is_active: true
  });
  const [errorFields, setErrorFields] = useState<any>();

  useEffect(() => { create(); }, []);

  const create = () => {
    showLoading?.('loading', 'Cargando formulario...');
    createCenter({
      onSuccess: (res: ServiceResponse) => {
        setSocieties(res.data?.societies ?? []);
        hideLoading?.();
      },
      onError: (response: ServiceResponse) => {
        hideLoading?.();
        toast.error(response.message);
        onError && onError();
      }
    });
  };

  const store = () => {
    showLoading?.('loading', 'Guardando centro...');
    storeCenter(center, {
      onSuccess: (response: ServiceResponse) => {
        hideLoading?.();
        toast.success(response.message, { autoClose: 2500 });
        onSaved && onSaved();
      },
      onError: (response: ServiceResponse) => {
        hideLoading?.();
        toast.error(response.message);
      },
      onFieldError: (errs: ServiceResponse) => {
        hideLoading?.();
        setErrorFields(errs.data);
      }
    });
  };

  return (
    <>
      <div className="row"><div className="col-12">
        <CenterForm
          centerDataForm={center}
          setCenterDataForm={setCenter}
          errorFields={errorFields}
          societiesOpts={societies}
        />
      </div></div>
      <div className="row justify-content-end">
        <div className="col-auto">
          <ButtonCancelForm callbackCancel={handleCancel} locked={!!fetchingStoreCenter} />
        </div>
        <div className="col-auto">
          <ButtonSaveForm callbackSave={store} locked={!!fetchingStoreCenter} />
        </div>
      </div>
    </>
  );
};


export default CenterCreate;
